module.exports = __webpack_public_path__ + "resources/img/logo_partner_game_9_m2.6fbe3baa3323534c0d162fe130f1f261.png";